import { useParams } from 'react-router-dom';
import { SECTION_STATUS } from './api';

/** Request id from the `/verification/<section>/:id` route. */
export const useRequestId = () => Number(useParams().id);

/** Section status, defaulting to "waiting" like the legacy pages. */
export const getSectionStatus = (status: number | undefined) => Number(status) || SECTION_STATUS.WAITING;
